import { Button, DatePicker, Drawer, Form, Input, InputNumber, Select, Space, Tabs, Tag } from 'antd';
import AccountReadinessStatus from './AccountReadinessStatus';
import {
  AGENT_TYPE_SELECT_OPTIONS,
  EXECUTION_POLICY_SELECT_OPTIONS,
  FALLBACK_POLICY_SELECT_OPTIONS,
  formatAgentTypeList,
  getExecutionPolicyLabel,
  getFallbackPolicyLabel,
} from '../utils/agentExecutionPolicy';

const TimedPublishTaskDetailDrawer = ({
  open,
  detailLoading,
  currentTask,
  onClose,
  onSave,
  activeTab,
  onTabChange,
  detailForm,
  taskTypeMap,
  statusMap,
  formatListField,
  formatDateTime,
  contentDeliveryPlatformOptions,
  hasTargetPlatforms,
  targetAccountLoading,
  targetAccountOptions,
  selectedTargetAccounts,
  getAccountPlatformLabel,
  getAuthStateColor,
}) => (
  <Drawer
    title="任务详情"
    placement="right"
    width={700}
    onClose={onClose}
    open={open}
    loading={detailLoading}
    mask
    maskStyle={{ backdropFilter: 'none', WebkitBackdropFilter: 'none' }}
    footer={(
      <div style={{ textAlign: 'right' }}>
        <Space>
          <Button onClick={onClose}>取消</Button>
          <Button type="primary" onClick={onSave}>保存</Button>
        </Space>
      </div>
    )}
  >
    {currentTask && (
      <Tabs
        activeKey={activeTab}
        onChange={onTabChange}
        items={[
          {
            key: 'preview',
            label: '任务信息',
            children: (
              <div style={{ padding: '16px 0' }}>
                <div style={{ marginBottom: 24 }}>
                  <h3 style={{ marginBottom: 8, fontSize: 18, fontWeight: 600 }}>基本信息</h3>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                    <div>
                      <div style={{ color: '#999', fontSize: 12, marginBottom: 4 }}>任务ID</div>
                      <div style={{ fontSize: 14, color: '#333' }}>{currentTask.task_id}</div>
                    </div>
                    <div>
                      <div style={{ color: '#999', fontSize: 12, marginBottom: 4 }}>任务类型</div>
                      <div style={{ fontSize: 14, color: '#333' }}>{taskTypeMap[currentTask.task_type] || currentTask.task_type}</div>
                    </div>
                    <div>
                      <div style={{ color: '#999', fontSize: 12, marginBottom: 4 }}>状态</div>
                      <div style={{ fontSize: 14 }}>
                        <Tag color={statusMap[currentTask.status]?.color}>
                          {statusMap[currentTask.status]?.text || currentTask.status}
                        </Tag>
                      </div>
                    </div>
                    <div>
                      <div style={{ color: '#999', fontSize: 12, marginBottom: 4 }}>创建者ID</div>
                      <div style={{ fontSize: 14, color: '#333' }}>{currentTask.creator_user_id || '-'}</div>
                    </div>
                    <div>
                      <div style={{ color: '#999', fontSize: 12, marginBottom: 4 }}>创建者</div>
                      <div style={{ fontSize: 14, color: '#333' }}>{currentTask.creator_user_name || '-'}</div>
                    </div>
                    <div>
                      <div style={{ color: '#999', fontSize: 12, marginBottom: 4 }}>账号管理员</div>
                      <div style={{ fontSize: 14, color: '#333', wordBreak: 'break-word' }}>
                        {formatListField(currentTask.operator_user_names)}
                      </div>
                    </div>
                    <div>
                      <div style={{ color: '#999', fontSize: 12, marginBottom: 4 }}>管理员ID</div>
                      <div style={{ fontSize: 14, color: '#333', wordBreak: 'break-word' }}>
                        {formatListField(currentTask.operator_user_ids)}
                      </div>
                    </div>
                    <div>
                      <div style={{ color: '#999', fontSize: 12, marginBottom: 4 }}>目标账号</div>
                      <div style={{ fontSize: 14, color: '#333', wordBreak: 'break-word' }}>
                        {formatListField(currentTask.target_account_names)}
                      </div>
                    </div>
                    <div>
                      <div style={{ color: '#999', fontSize: 12, marginBottom: 4 }}>创建时间</div>
                      <div style={{ fontSize: 14, color: '#333' }}>{formatDateTime(currentTask.created_at)}</div>
                    </div>
                    <div>
                      <div style={{ color: '#999', fontSize: 12, marginBottom: 4 }}>更新时间</div>
                      <div style={{ fontSize: 14, color: '#333' }}>{formatDateTime(currentTask.updated_at)}</div>
                    </div>
                  </div>
                </div>
                {currentTask.schedule && (
                  <div style={{ marginBottom: 24 }}>
                    <h3 style={{ marginBottom: 8, fontSize: 18, fontWeight: 600 }}>定时规则</h3>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                      <div>
                        <div style={{ color: '#999', fontSize: 12, marginBottom: 4 }}>触发类型</div>
                        <div style={{ fontSize: 14, color: '#333' }}>{currentTask.schedule.trigger_type}</div>
                      </div>
                      {currentTask.schedule.cron_expression && (
                        <div>
                          <div style={{ color: '#999', fontSize: 12, marginBottom: 4 }}>Cron表达式</div>
                          <div style={{ fontSize: 14, color: '#333' }}>{currentTask.schedule.cron_expression}</div>
                        </div>
                      )}
                      {currentTask.schedule.run_at && (
                        <div>
                          <div style={{ color: '#999', fontSize: 12, marginBottom: 4 }}>执行时间</div>
                          <div style={{ fontSize: 14, color: '#333' }}>{formatDateTime(currentTask.schedule.run_at)}</div>
                        </div>
                      )}
                      {currentTask.schedule.interval_seconds && (
                        <div>
                          <div style={{ color: '#999', fontSize: 12, marginBottom: 4 }}>间隔（秒）</div>
                          <div style={{ fontSize: 14, color: '#333' }}>{currentTask.schedule.interval_seconds}</div>
                        </div>
                      )}
                      {currentTask.schedule.start_at && (
                        <div>
                          <div style={{ color: '#999', fontSize: 12, marginBottom: 4 }}>起始时间</div>
                          <div style={{ fontSize: 14, color: '#333' }}>{formatDateTime(currentTask.schedule.start_at)}</div>
                        </div>
                      )}
                      {currentTask.schedule.end_at && (
                        <div>
                          <div style={{ color: '#999', fontSize: 12, marginBottom: 4 }}>结束时间</div>
                          <div style={{ fontSize: 14, color: '#333' }}>{formatDateTime(currentTask.schedule.end_at)}</div>
                        </div>
                      )}
                      {currentTask.schedule.timezone && (
                        <div>
                          <div style={{ color: '#999', fontSize: 12, marginBottom: 4 }}>时区</div>
                          <div style={{ fontSize: 14, color: '#333' }}>{currentTask.schedule.timezone}</div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {currentTask.filters && (
                  <div style={{ marginBottom: 24 }}>
                    <h3 style={{ marginBottom: 8, fontSize: 18, fontWeight: 600 }}>筛选条件</h3>
                    <div style={{ fontSize: 14, color: '#666', lineHeight: 1.8 }}>
                      {JSON.stringify(currentTask.filters, null, 2)}
                    </div>
                  </div>
                )}
                {currentTask.target_platforms && currentTask.target_platforms.length > 0 && (
                  <div style={{ marginBottom: 24 }}>
                    <h3 style={{ marginBottom: 8, fontSize: 18, fontWeight: 600 }}>目标平台</h3>
                    <Space size={[0, 8]} wrap>
                      {currentTask.target_platforms.map((platform, index) => (
                        <Tag key={index}>{platform}</Tag>
                      ))}
                    </Space>
                  </div>
                )}
                <div style={{ marginBottom: 24 }}>
                  <h3 style={{ marginBottom: 8, fontSize: 18, fontWeight: 600 }}>执行策略</h3>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                    <div>
                      <div style={{ color: '#999', fontSize: 12, marginBottom: 4 }}>执行策略</div>
                      <div style={{ fontSize: 14, color: '#333' }}>{getExecutionPolicyLabel(currentTask.execution_policy)}</div>
                    </div>
                    <div>
                      <div style={{ color: '#999', fontSize: 12, marginBottom: 4 }}>允许节点类型</div>
                      <div style={{ fontSize: 14, color: '#333' }}>{formatAgentTypeList(currentTask.allowed_agent_types)}</div>
                    </div>
                    <div>
                      <div style={{ color: '#999', fontSize: 12, marginBottom: 4 }}>指定优先 Agent</div>
                      <div style={{ fontSize: 14, color: '#333', wordBreak: 'break-all' }}>{currentTask.preferred_agent_id || '-'}</div>
                    </div>
                    <div>
                      <div style={{ color: '#999', fontSize: 12, marginBottom: 4 }}>回退策略</div>
                      <div style={{ fontSize: 14, color: '#333' }}>{getFallbackPolicyLabel(currentTask.fallback_policy)}</div>
                    </div>
                  </div>
                </div>
                <div style={{ marginBottom: 24 }}>
                  <h3 style={{ marginBottom: 8, fontSize: 18, fontWeight: 600 }}>执行统计</h3>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px' }}>
                    <div>
                      <div style={{ color: '#999', fontSize: 12, marginBottom: 4 }}>总执行次数</div>
                      <div style={{ fontSize: 14, color: '#333' }}>{currentTask.total_run_count || 0}</div>
                    </div>
                    <div>
                      <div style={{ color: '#999', fontSize: 12, marginBottom: 4 }}>成功次数</div>
                      <div style={{ fontSize: 14, color: '#52c41a' }}>{currentTask.total_success_count || 0}</div>
                    </div>
                    <div>
                      <div style={{ color: '#999', fontSize: 12, marginBottom: 4 }}>失败次数</div>
                      <div style={{ fontSize: 14, color: '#ff4d4f' }}>{currentTask.total_failure_count || 0}</div>
                    </div>
                  </div>
                </div>
              </div>
            ),
          },
          {
            key: 'edit',
            label: '编辑任务',
            children: (
              <Form form={detailForm} layout="vertical" style={{ padding: '16px 0' }}>
                <Form.Item
                  label="任务名称"
                  name="task_name"
                  rules={[{ required: true, message: '请输入任务名称' }]}
                >
                  <Input placeholder="请输入任务名称" />
                </Form.Item>

                <Form.Item
                  label="每账号最多发布条数"
                  name="max_items_per_account_per_run"
                  initialValue={1}
                  rules={[{ required: true, message: '请输入条数' }]}
                >
                  <InputNumber min={1} max={50} style={{ width: '100%' }} />
                </Form.Item>

                <Form.Item
                  label="任务并发数"
                  name="max_concurrency"
                  initialValue={3}
                  rules={[{ required: true, message: '请输入并发数' }]}
                >
                  <InputNumber min={1} max={10} style={{ width: '100%' }} />
                </Form.Item>

                <div style={{ margin: '8px 0 16px 0', padding: 12, border: '1px solid #f0f0f0', borderRadius: 8, background: '#fafafa' }}>
                  <div style={{ fontWeight: 600, marginBottom: 10 }}>高级执行策略</div>
                  <Form.Item
                    label="执行策略"
                    name="execution_policy"
                    rules={[{ required: true, message: '请选择执行策略' }]}
                  >
                    <Select options={EXECUTION_POLICY_SELECT_OPTIONS} />
                  </Form.Item>

                  <Form.Item
                    label="允许节点类型"
                    name="allowed_agent_types"
                    rules={[{ required: true, message: '请选择至少一个节点类型' }]}
                  >
                    <Select mode="multiple" options={AGENT_TYPE_SELECT_OPTIONS} />
                  </Form.Item>

                  <Form.Item
                    label="指定优先 Agent（可选）"
                    name="preferred_agent_id"
                  >
                    <Input placeholder="例如：agent_xxx" />
                  </Form.Item>

                  <Form.Item
                    label="回退策略"
                    name="fallback_policy"
                    rules={[{ required: true, message: '请选择回退策略' }]}
                  >
                    <Select options={FALLBACK_POLICY_SELECT_OPTIONS} />
                  </Form.Item>

                  <Space size={12} wrap style={{ width: '100%' }}>
                    <Form.Item label="max_switch_retry" name="retry_strategy_max_switch_retry" style={{ minWidth: 220 }}>
                      <InputNumber min={0} max={10} style={{ width: '100%' }} />
                    </Form.Item>
                    <Form.Item label="cooldown_sec" name="retry_strategy_cooldown_sec" style={{ minWidth: 220 }}>
                      <InputNumber min={0} max={86400} style={{ width: '100%' }} />
                    </Form.Item>
                  </Space>
                </div>

                <Form.Item
                  label="状态"
                  name="status"
                  rules={[{ required: true, message: '请选择状态' }]}
                >
                  <Select placeholder="请选择状态">
                    <Select.Option value="active">运行中</Select.Option>
                    <Select.Option value="paused">已停用</Select.Option>
                    <Select.Option value="completed">已完成</Select.Option>
                    <Select.Option value="failed">失败</Select.Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  label="触发类型"
                  name="trigger_type"
                  rules={[{ required: true, message: '请选择触发类型' }]}
                >
                  <Select placeholder="请选择触发类型">
                    <Select.Option value="cron">定时任务 (Cron)</Select.Option>
                    <Select.Option value="interval">间隔任务</Select.Option>
                    <Select.Option value="once">单次任务</Select.Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  noStyle
                  shouldUpdate={(prevValues, currentValues) => prevValues.trigger_type !== currentValues.trigger_type}
                >
                  {({ getFieldValue }) => {
                    const triggerType = getFieldValue('trigger_type');
                    if (triggerType === 'cron') {
                      return (
                        <>
                          <Form.Item
                            label="Cron表达式"
                            name="cron_expression"
                            rules={[{ required: true, message: '请输入Cron表达式' }]}
                          >
                            <Input placeholder="例如: 0 3 * * *" />
                          </Form.Item>
                          <Form.Item
                            label="时区"
                            name="timezone"
                          >
                            <Input placeholder="例如: Asia/Shanghai" />
                          </Form.Item>
                        </>
                      );
                    }

                    if (triggerType === 'interval') {
                      return (
                        <>
                          <Form.Item
                            label="间隔（秒）"
                            name="interval_seconds"
                            rules={[{ required: true, message: '请输入间隔秒数' }]}
                          >
                            <InputNumber min={1} style={{ width: '100%' }} placeholder="例如: 3600（每 1 小时）" />
                          </Form.Item>
                          <Form.Item label="起始时间（可选）" name="start_at">
                            <DatePicker
                              showTime
                              format="YYYY-MM-DD HH:mm:ss"
                              style={{ width: '100%' }}
                              placeholder="不填则立即生效"
                            />
                          </Form.Item>
                          <Form.Item label="结束时间（可选）" name="end_at">
                            <DatePicker
                              showTime
                              format="YYYY-MM-DD HH:mm:ss"
                              style={{ width: '100%' }}
                              placeholder="不填则一直执行"
                            />
                          </Form.Item>
                          <Form.Item
                            label="时区"
                            name="timezone"
                          >
                            <Input placeholder="例如: Asia/Shanghai" />
                          </Form.Item>
                        </>
                      );
                    }

                    return (
                      <>
                        <Form.Item
                          label="执行时间"
                          name="run_at"
                          rules={[{ required: true, message: '请选择执行时间' }]}
                        >
                          <DatePicker
                            showTime
                            format="YYYY-MM-DD HH:mm:ss"
                            style={{ width: '100%' }}
                            placeholder="请选择执行时间"
                          />
                        </Form.Item>
                        <Form.Item
                          label="时区"
                          name="timezone"
                        >
                          <Input placeholder="例如: Asia/Shanghai" />
                        </Form.Item>
                      </>
                    );
                  }}
                </Form.Item>

                <Form.Item
                  label="内容类型"
                  name="content_types"
                >
                  <Select mode="multiple" placeholder="请选择内容类型" allowClear>
                    <Select.Option value="视频">视频</Select.Option>
                    <Select.Option value="图文">图文</Select.Option>
                    <Select.Option value="笔记">笔记</Select.Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  label="内容来源"
                  name="content_sources"
                >
                  <Select mode="multiple" placeholder="请选择内容来源" allowClear>
                    <Select.Option value="自建">自建</Select.Option>
                    <Select.Option value="抓取">抓取</Select.Option>
                    <Select.Option value="AI生成">AI生成</Select.Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  label="目标平台"
                  name="target_platforms"
                  rules={[{ required: true, message: '请选择目标平台' }]}
                >
                  <Select
                    mode="multiple"
                    placeholder="请选择目标平台"
                    allowClear
                    options={contentDeliveryPlatformOptions}
                  />
                </Form.Item>

                <Form.Item
                  label="目标账号"
                  name="target_account_ids"
                >
                  <Select
                    mode="multiple"
                    placeholder={hasTargetPlatforms ? '请选择目标账号' : '请先选择目标平台'}
                    allowClear
                    showSearch
                    loading={targetAccountLoading}
                    options={targetAccountOptions}
                    optionFilterProp="label"
                    disabled={!hasTargetPlatforms}
                  />
                </Form.Item>

                {selectedTargetAccounts.length > 0 ? (
                  <div
                    style={{
                      padding: 12,
                      marginBottom: 16,
                      border: '1px solid #f0f0f0',
                      borderRadius: 8,
                      background: '#fafafa',
                    }}
                  >
                    <div style={{ fontWeight: 600, marginBottom: 8 }}>目标账号状态</div>
                    <Space direction="vertical" size={8} style={{ width: '100%' }}>
                      {selectedTargetAccounts.map((account) => (
                        <div
                          key={account.account_id}
                          style={{ padding: 12, borderRadius: 6, background: '#fff' }}
                        >
                          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                            <Tag color="blue">{getAccountPlatformLabel(account)}</Tag>
                            <span style={{ marginRight: 8 }}>账号ID: {account.account_id}</span>
                            <span>账号名: {account.account_name || '-'}</span>
                            {account?.login_readiness?.auth_state ? (
                              <Tag color={getAuthStateColor(account.login_readiness.auth_state)}>
                                {account.login_readiness.auth_state}
                              </Tag>
                            ) : null}
                          </div>
                          <AccountReadinessStatus account={account} />
                        </div>
                      ))}
                    </Space>
                  </div>
                ) : null}
              </Form>
            ),
          },
        ]}
      />
    )}
  </Drawer>
);

export default TimedPublishTaskDetailDrawer;
